import { Box, L40, L88 } from "@adfenix/alexandria";

import styled from "styled-components";

const Card = styled(({ ...rest }) => <Box p={["s", "xl2"]} {...rest} />)`
  color: ${({ theme }) => L40(theme.colors.grey)};
  background-color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.borderRadius.m}
  box-shadow: 0 1px 4px 0 ${({ theme }) =>
    L88(theme.colors.grey)}, 0 0 0 1px ${({ theme }) => L88(theme.colors.grey)};
`;

export default Card;
